import { render } from "./TrayPanelPresets.vue?vue&type=template&id=13cbf0d9&scoped=true"
import script from "./TrayPanelPresets.vue?vue&type=script&lang=js"
export * from "./TrayPanelPresets.vue?vue&type=script&lang=js"

import "../styles/TrayPanelPresets.scss?vue&type=style&index=0&id=13cbf0d9&scoped=true&lang=scss"

import exportComponent from "/home/runner/work/biology-microscopy/biology-microscopy/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13cbf0d9"]])

export default __exports__